import { apiHost, createOne, CrudApi, deleteOne, queryList, queryOne, queryPage, updateOne } from "../../shared/technical/rest/restApi";
import { User, UserDetails } from "./User";
import { AxiosInstance } from "axios";
import { fullPageable, Pageable, PagedResult } from "../../shared/technical/rest/pageable";
import { handleErrorResponse, handleSuccessResponse } from "../../shared/technical/rest/errorHandling";
import { KeycloakUser } from "./KeycloakUser";
import { downloadFile } from "../../shared/technical/file-utils/downloadFile";

export const userCrudApi: CrudApi<User, UserDetails> = {
  queryPage: getAllUsers,
  queryOne: getUser,
  createOne: createUser,
  updateOne: updateUser,
  deleteOne: deleteUser
}

export function getAllUsers(axios: AxiosInstance, pageable: Pageable, params?: string): Promise<PagedResult<User>> {
  return queryPage(axios, 'users', pageable, params)
}

export function getKeycloakUsers(axios: AxiosInstance): Promise<KeycloakUser[]> {
  return queryList(axios, 'users/from-keycloak')
}

export function getUserByEmail(axios: AxiosInstance, email: string): Promise<UserDetails | undefined> {
  return queryPage(axios, 'users', fullPageable(), 'email=' + encodeURIComponent(email)).then(page =>
    page.page.totalElements > 0 ? page.content[0] as UserDetails : undefined)
}

export function getUser(axios: AxiosInstance, id: string | number): Promise<UserDetails> {
  return queryOne(axios, 'users', id)
}

export function createUser(axios: AxiosInstance, user: User): Promise<UserDetails> {
  return createOne(axios, 'users', user)
}

export function updateUser(axios: AxiosInstance, user: UserDetails): Promise<UserDetails> {
  return updateOne(axios, 'users', user)
}

export function deleteUser(axios: AxiosInstance, userId: string | number): Promise<void> {
  return deleteOne(axios, 'users', userId)
}

export function sendPasswordMailToUser(axios: AxiosInstance, userId: string | number): Promise<void> {
  const baseUri = apiHost + '/users/' + userId + '/update-password' ;
  return axios.post(baseUri)
    .then(handleSuccessResponse, handleErrorResponse);
}

export function sendRegistrationMailToUser(axios: AxiosInstance, userId: string | number): Promise<void> {
  const baseUri = apiHost + '/users/' + userId + '/registration-mail' ;
  return axios.post(baseUri)
    .then(handleSuccessResponse, handleErrorResponse);
}

export function enableUser(axios: AxiosInstance, userId: string | number): Promise<UserDetails> {
  const baseUri = apiHost + '/users/' + userId + '/enabled' ;
  return axios.post(baseUri)
    .then(handleSuccessResponse, handleErrorResponse);
}

export function disableUser(axios: AxiosInstance, userId: string | number): Promise<UserDetails> {
  const baseUri = apiHost + '/users/' + userId + '/enabled' ;
  return axios.delete(baseUri)
    .then(handleSuccessResponse, handleErrorResponse);
}

export function exportUsersCsv(axios: AxiosInstance, params?: string): Promise<void> {
  return downloadFile(axios, 'users/export', 'text/csv', params );
}
